import ProjectService from '../../project.service.js';
import Service from '@/service/index.js';
import Pagination from '@/components/pagination/index.vue';
import { errorMessage, successMessage } from '@/utils/message.js';
import { changeSkin } from '@/utils/common.js';
import QrCodePage from '@/components/qr-code/index.vue';
const debounce = require('lodash.debounce');
import updateBankMixins from '@/utils/mixins/update-bank-mixins.js';
export default {
  mixins: [updateBankMixins],
  components: {
    Pagination,
    QrCodePage
  },
  data() {
    return {
      projectBidStatusArr: [],
      projectTypeArr: [],
      tradeTypeArr: [],
      total: 0,
      currentPage: 1,
      pageSize: 5,
      tableList: [],
      qrCodeVisible: false,
      projectId: ''
    };
  },
  created() {
    const arr = [
      ['projectBidStatusArr', 'PROJECT_BID_STATUS'],
      ['projectTypeArr', 'PROJECT_TYPE'],
      ['tradeTypeArr', 'TRADE_TYPE']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          this[value[0]] = res.data;
        }
      });
    });
    this.getContractedProjectList();
  },
  computed: {
  },
  methods: {
    changeSkin,
    // 收不到签约短信
    qrCodeClick(projectId) {
      this.projectId = projectId;
      this.qrCodeVisible = true;
    },
    // 项目类型两级拼接
    projectTypeText (projectItem) {
      if (!this.projectTypeArr.length) {return ''; }
      const obj = this.projectTypeArr.find(item => item.code === String(projectItem.projectType));
      if (obj) {
        const subObj = obj.list && obj.list.find(item => item.code === String(projectItem.projectSubType));
        if (subObj) {
          return obj.value + ' · ' + subObj.value;
        } else {
          return obj.value;
        }
      } else {
        return '';
      }
    },
    // 按钮显示文案
    btnText (status) {
      switch(status) {
      case 20: {
        return '上传材料';
      }
      case 80: {
        return '确认竞价结果';
      }
      case 82: {
        return '确认合同';
      }
      case 85: {
        return '支付合同款';
      }
      default: {
        return '';
      }
      }
    },
    // 按钮操作
    btnAction (item) {
      const status = item.bidStatus;
      if (status === 20) {
        this.$router.push('/person-center/project/contracted-project/upload-material?projectId=' + item.projectId + '&bidId=' + item.bidId);
      }
      if (status === 80) {
        this.$router.push('/person-center/project/contracted-project/confirm-deal-book?projectId=' + item.projectId + '&bidId=' + item.bidId);
      }
      else if (status === 82) {
        this.$router.push('/person-center/project/contracted-project/confirm-contract?projectId=' + item.projectId + '&bidId=' + item.bidId + '&projectType=' + item.projectType + '&projectSubType=' + item.projectSubType);
      }
      else if (status === 85) {
        this.$router.push('/person-center/project/contracted-project/contract-payment?projectId=' + item.projectId);
      }
    },
    // 跳转项目文件
    goPushFilelist(projectId, projectCode) {
      this.$router.push('/person-center/project/contracted-project/contract-file-list?id=' + projectId + '&projectCode=' + projectCode);
    },
    // 项目结算
    settleProject: debounce(function(bidId) {
      ProjectService.tradeProjectSettlement(bidId).then(res => {
        if (res && res.code === '0') {
          this.$alert('项目结算成功', '提示', {
            confirmButtonText: '确定',
            callback: () => {
              this.getContractedProjectList();
            }
          });
        } else {
          errorMessage(res && res.reason);
        }
      }).catch(error => {
        if (error && error.data && error.data.reason) {
          this.$errorMessage(error.data.reason);
        } else {
          this.$errorMessage('项目结算失败');
        }
      });
    }, 2000, {
      'leading': true,
      'trailing': false
    }),
    // 获取发布项目列表
    getContractedProjectList(page){
      if (page) {
        this.currentPage = page.pageNo;
        this.pageSize = page.pageSize;
      }
      ProjectService.getContractedProjectList(this.currentPage, this.pageSize).then(res => {
        if (res && res.code === '0') {
          this.total = res.data.total;
          this.tableList = res.data.list;
        }
      });
    },
    goToDetail (item) {
      if(Number(item.tradeType) === 1) {
        window.open(window.location.origin + '/#/transaction-pro/detail?id=' + item.projectId);
      }
    },
    // 线上签约——申请签署合同
    applyContract: debounce(function(obj){
      let params = {
        projectType: obj.projectType,
        projectId: obj.projectId
      };
      ProjectService.applySignContract(params).then(res => {
        if (res && res.code === '0') {
          successMessage('发送签约短信成功');
        } else if (res && res.reason) {
          errorMessage(res && res.reason);
        } else {
          errorMessage('发送签约短信失败');
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('发送签约短信失败');
        }
      });
    }, 2000, {
      'leading': true,
      'trailing': false
    }),
    // 线下签约——下载合同
    downloadContract: debounce(function(projectType, projectSubType, tradeType){
      ProjectService.downloadContractDemo(projectType, projectSubType, tradeType).then(res => {
        if (res && res.code === '0') {
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = 'data:file/doc;base64,' + res.data;
          link.download = '产权交易合同.doc';
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(link.href);
          successMessage('合同下载成功');
        } else if (res && res.reason) {
          errorMessage(res && res.reason);
        } else {
          errorMessage('合同下载失败');
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('合同下载失败');
        }
      });
    }, 2000, {
      'leading': true,
      'trailing': false
    })
  }
};
